import { Grid, Typography } from '@material-ui/core'
import { FC, Fragment } from 'react'
import { ReduxFormField } from '../../../../components/FormInput/ReduxWrappers'
import { BasicFieldProps } from '../../../../types/forms'
import { required } from '../../../../utils/validation/forms'
import { MyInput } from '../../../NewApplication/Fields'

const BusinessClient: FC<BasicFieldProps> = ({ t, isDisabled, classes }) => (
  <Fragment>
    <Grid item xs={12} sm={6} className={classes?.containerItem}>
      <Typography variant='body1' gutterBottom>
        {t('business.companyName')}
      </Typography>
      <ReduxFormField
        name='mainOwner.companyName'
        validate={[required]}
        disabled={isDisabled}
        component={MyInput}
        style={{
          width: '100%',
          height: '58px',
          padding: '20px',
          background: '#E7ECEF'
        }}
        required
      />
    </Grid>
    <Grid item xs={12} sm={6} className={classes?.containerItem}>
      <Typography variant='body1' gutterBottom>
        {t('business.businessId')}
      </Typography>
      <ReduxFormField
        name='mainOwner.businessId'
        validate={[required]}
        disabled={isDisabled}
        component={MyInput}
        style={{
          width: '100%',
          height: '58px',
          padding: '20px',
          background: '#E7ECEF'
        }}
        required
      />
    </Grid>
  </Fragment>
)

export default BusinessClient
